import { render, staticRenderFns } from "./onlyList.vue?vue&type=template&id=6f666022&scoped=true"
import script from "./onlyList.vue?vue&type=script&lang=js"
export * from "./onlyList.vue?vue&type=script&lang=js"
import style0 from "./onlyList.vue?vue&type=style&index=0&id=6f666022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f666022",
  null
  
)

export default component.exports